/**
 * Konstanty dárkového poukazu bez `zod` — klientský konfigurátor webu je čte přes
 * `@ckgo2/shared/client`, server přes `schemas/index.ts` (`giftVoucherCreateSchema`, který je
 * importuje a reexportuje pod týmiž jmény). Řez 13 (F10.5): klient bez zod.
 *
 * Meze a nabídnuté částky dárkového poukazu — JEDEN zdroj pro serverovou validaci
 * (`giftVoucherCreateSchema`) i pro konfigurátor na webu.
 *
 * Než tohle vzniklo, web nabízel „50–10 000 USD" a přednastavené částky 100/250/500/750/…,
 * zatímco server vyžadoval 1 000–500 000 Kč — pět ze šesti nabídnutých hodnot skončilo 400
 * a výchozí volba nešla koupit vůbec. Dvě kopie čísel proto být nesmí.
 */
export const GIFT_VOUCHER_AMOUNT_MIN = 1000;
export const GIFT_VOUCHER_AMOUNT_MAX = 500000;
/** Nabídnutá tlačítka konfigurátoru (Kč). Každá hodnota musí projít schématem `giftVoucherCreateSchema`. */
export const GIFT_VOUCHER_PRESETS = [1000, 2000, 5000, 10000, 20000, 50000] as const;
/** Předvybraná částka po otevření konfigurátoru. */
export const GIFT_VOUCHER_DEFAULT_AMOUNT = 5000;
/**
 * Krok pole „vlastní částka" na webu. Musí zůstat `1`, protože schéma bere KAŽDÉ celé
 * číslo v rozsahu: `<input type="number">` vynucuje mřížku `min + n*step` nativní validací
 * prohlížeče, tedy DŘÍV, než se vůbec spustí odeslání formuláře. S krokem 500 by prohlížeč
 * odmítl vlastní bublinou třeba 3 700 Kč, kterou server přijme — rozpor mezi nabídkou
 * a validací by se tím jen přesunul z Zodu do prohlížeče.
 */
export const GIFT_VOUCHER_AMOUNT_STEP = 1;
